import $ from 'jquery';

import {util} from './util';

export const emailAndZipSubmit = {
  init(modal) {

    function showInvalidEmailError() {
      const $emailError = $('.email-error');
      $emailError.text('Please enter a valid email address.');
      $emailError.slideDown();
    }

    function showEmailInUseError() {
      const $emailError = $('.email-error');
      const errorText = (
        'It looks like you\'ve already created an account with us. ' +
        'Please <a href="/account/login">log in here</a> ' +
        'to manage your deliveries.'
      );
      $emailError.html(errorText);
      $emailError.slideDown();
    }

    function showZipNotServedError() {
      const $zipError = $('.zip-error');
      $zipError.text('Sorry! We don’t deliver to your area yet. Check back soon to see if your zip code has been added to our delivery range!');
      $zipError.slideDown();
    }

    $(document).ready(() => {

      // Prepopulate email and zip
      $('#ca-form .ca-form-zip-field').val(util.getUrlParam('zip_code'));
      $('#ca-form .ca-form-email-field').val(decodeURIComponent(util.getUrlParam('email') || ''));

      const giftABox = window.location.href.indexOf('gift-a-box') > -1;

      if ($('#default-discount-code').val()) {
        var overwriteCode = true;
      } else {
        var overwriteCode = false;
      }

      // Process the discount and overwrite anything old
      // util.processDiscountCode(function() {
      //   console.log('email cb')

      //   var dc = util.getDiscountCode();

      //   if(dc) {
      //     // Print the discount code on the page
      //     $(".discount-code-name").html(dc.code.toUpperCase());
      //   }

      // }, $("#default-discount-code").val(), overwriteCode);

      // On zip field keydown, remove error and check whether new zip is valid
      $('.ca-form-zip-field').keydown(function() {

        $('.zip-error').removeClass('slidedown').addClass('slideup');

        const zip_length = $(this).val().length;
        if (util.validZip(this.value) === null) {
          if (zip_length == 5) {
            $('.zip-error').slideDown();
          } else {
            $('.zip-error').slideUp();
          }
        }
      });

      if (!giftABox) {
        // On email field keydown, remove all errors
        $('.ca-form-email-field').keydown(() => {
          $('.email-error').slideUp();
        });
      }

      // On form submit...
      $('.ca-form-submit').click((evt) => {

        // Prevent this form from submitting
        evt.preventDefault();

        // Store the form and button clicked in variables
        const $form = $(evt.target.closest('form'));
        const $button = $(evt.target);
        const $zipError = $form.find('.zip-error');
        const $emailError = $form.find('.email-error');

        // Store the zip code, email, and original button text as variables
        const freq = $form.find('input[type="hidden"][name="frequency"]').val();
        const prepopulatedMeals = $form.find('input[type="hidden"][name="prepopulated_meals"]').val();
        const zip = $form.find('.ca-form-zip-field').val();
        const pageSource = $form.data('signupSource') || 'Check Availability';
        const klaviyoListId = $form.data('klaviyoListId');
        const email = $form.find('.ca-form-email-field').val() || decodeURIComponent(util.getUrlParam('email') || '');
        const emailInUseOkay = ($form.find('input[name="email_in_use_okay"]').val() === 'true');
        const userSegmentation = $form.find('input[name="user_segmentation"]').val();
        const originalButtonText = $($button).html();

        let emailRequired = (util.getUrlParam('email_required', 'true') === 'true');
        if ($form.find('input[name="email_required"]').length) {
          if ($form.find('input[name="email_required"]').val() == 'false') {
            emailRequired = false;
          }
        }

        const checkingMessage = 'Checking availability...';
        const successMessage = giftABox ? 'Available!' : 'We ship to you!';

        // Activate processing state
        util.buttonToProcessingState($($button), checkingMessage);

        // Save Google Optimize state
        if (freq) {
          window.basket.setOptimizeProperty('frequency', freq);
        } else {
          window.basket.unsetOptimizeProperty('frequency');
        }

        if (prepopulatedMeals) {
          window.basket.setOptimizeProperty('prepopulatedMeals', decodeURIComponent(prepopulatedMeals).split(',').map((id) => Number(id)));
        } else {
          window.basket.unsetOptimizeProperty('prepopulatedMeals');
        }

        // Remove all errors
        $($zipError).slideUp();
        if (!giftABox) {
          $($emailError).slideUp();
        }

        // If the zipcode submitted is invalid, show error and return button to normal state
        if (util.validZip(zip) === null) {
          $($zipError).slideDown();
          util.buttonToNormalState($button, originalButtonText);
          return;
        } else {
          $($zipError).slideUp();
        }

        if (!giftABox && emailRequired) {
          // If the email submitted is invalid, show error and return button to normal state
          if (util.validEmail(email) === null) {
            showInvalidEmailError();
            util.buttonToNormalState($($button), originalButtonText);
            return;
          } else {
            $($emailError).slideUp();
          }
        }

        util.checkAvailability({
          user_email: email,
          shipping_zipcode: zip,
          errorCallback(err) {
            // Let the user proceed on any error.
            util.buttonToCompletedState($($button), successMessage);

            setTimeout(() => {
              if (modal) {
                util.insertUrlParam('zip_code', zip);
                modal.close();
              } else {
                $form.submit();
              }
            }, 500);
          },
          completeCallback(res) {
            if (!giftABox) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({event: 'checkAvailability'});
              window.Shopify.analytics.publish('mosaicCheckAvailability', {
                email,
                zipcode: zip,
                zipCodeIsServed: res.zipcode_served,
                utmParams: window.basket.getUTM(),
                pageSource,
                klaviyoListId,
              });
            }

            if (res.fc_shortcode) {
              window.basket.setFulfillmentCenter(res.fc_shortcode);
            }

            if (res.display_shipping || res.display_shipping_smallest_plan) {
              window.basket.setDisplayShipping(res.display_shipping || res.display_shipping_smallest_plan);
            }

            if (!res.zipcode_served) {
              window.basket.unsetFulfillmentCenter();
              window.basket.unsetDisplayShipping();
              if (themeConfiguration.redirectOnUnavailZip) {
                window.location.assign('/pages/we-dont-ship-to-your-location');
              } else {
                showZipNotServedError();
                util.buttonToNormalState($($button), originalButtonText);
              }
            } else if (res.email_in_use && !emailInUseOkay) {
              showEmailInUseError();
              util.buttonToNormalState($($button), originalButtonText);
            } else {
              util.buttonToCompletedState($($button), successMessage);

              /**
               * GTM - identifyUser
               */
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: 'identifyUser',
                userProperties: {
                  email,
                  zipcode: zip,
                  fulfillment_center: res.fc_shortcode,
                  ...userSegmentation && {
                    user_segmentation: userSegmentation,
                  },
                },
              });


              setTimeout(() => {
                if (modal) {
                  util.insertUrlParam('zip_code', zip);
                  modal.close();
                } else {
                  $form.submit();
                }
              }, 500);
            }
          },
        });
      });

      // On form submit...
      $(document).on('click', '.newsletter-form-submit', (evt) => {

        // Prevent this form from submitting
        evt.preventDefault();

        // Store the form and button clicked in variables
        const $form = $(evt.target.closest('form'));
        const $button = $(evt.target);
        const $zipError = $form.find('.zip-error');
        const $emailError = $form.find('.email-error');
        const pageSource = $form.data('signupSource') || 'Newsletter';
        const klaviyoListId = $form.data('klaviyoListId');

        // Store the zip code, email, and original button text as variables
        const zip = $form.find('.newsletter-form-zip-field').val();
        const email = $form.find('.newsletter-form-email-field').val();
        const userSegmentation = $form.find('input[name="user_segmentation"]').val();
        const originalButtonText = $($button).html();

        const checkingMessage = 'Processing...';
        const successMessage = 'Signed up!';

        // Activate processing state
        util.buttonToProcessingState($($button), checkingMessage);

        // Remove all errors
        $($zipError).slideUp();
        $($emailError).slideUp();

        // If the zipcode submitted is invalid, show error and return button to normal state
        if (util.validZip(zip) === null) {
          $($zipError).slideDown();
          util.buttonToNormalState($button, originalButtonText);
          return;
        } else {
          $($zipError).slideUp();
        }

        // If the email submitted is invalid, show error and return button to normal state
        if (util.validEmail(email) === null) {
          showInvalidEmailError();
          util.buttonToNormalState($($button), originalButtonText);
          return;
        } else {
          $($emailError).slideUp();
        }

        const newsletterSubmitEvent = new CustomEvent('newsletter:submit');

        util.checkAvailability({
          user_email: email,
          shipping_zipcode: zip,
          errorCallback(err) {
            // Let the user proceed on any error.
            util.buttonToCompletedState($($button), successMessage);

            setTimeout(() => {
              util.buttonToNormalState($($button), originalButtonText);
            }, 1500);
            document.dispatchEvent(newsletterSubmitEvent);
          },
          completeCallback(res) {
            window.Shopify.analytics.publish('mosaicCheckAvailability', {
              email,
              zipcode: zip,
              zipCodeIsServed: res.zipcode_served,
              utmParams: window.basket.getUTM(),
              pageSource,
              klaviyoListId,
            });

            util.buttonToCompletedState($($button), successMessage);

            /**
             * GTM - identifyUser
             */
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'identifyUser',
              userProperties: {
                email,
                zipcode: zip,
                fulfillment_center: res.fc_shortcode,
                ...userSegmentation && {
                  user_segmentation: userSegmentation,
                },
              },
            });

            setTimeout(() => {
              util.buttonToNormalState($($button), originalButtonText);
            }, 1500);
            document.dispatchEvent(newsletterSubmitEvent);
          },
        });
      });
    });
  },
};
